import LoginForm from "../../commen/form/login/LoginForm";
import "./LoginPage";
const LoginPage = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default LoginPage;
